var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"formOrgName",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-text-field',{attrs:{"label":"Företagsnamn*","rules":[_vm.orgNameRule]},model:{value:(_vm.orgName),callback:function ($$v) {_vm.orgName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"orgName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }